import { atom } from 'recoil';

export const chatSettingsOpenState = atom<boolean>({
  key: 'chatSettingsOpen',
  default: false
});

export const userSettingsOpenState = atom<boolean>({
  key: 'userSettingsOpen',
  default: false
});
